import { useEffect } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import styles from "./styles.module.css";
import ManageNavebar from "../../utils/ManageNavbar/ManageNavebar";
import MainNavbar from "../../utils/MainNavbar/MainNavbar";
import { ROUTES } from "const";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function ManageLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === ROUTES.MANAGE && window.innerWidth > 768) {
      navigate(ROUTES.PRODUCTS, { replace: true });
    }
  }, [location.pathname, navigate]);

  const isMenuOnly = location.pathname === ROUTES.MANAGE;

  return (
    <div className={styles.container}>
      <div className={styles.navbar}>
        <MainNavbar />
      </div>
      <div className={`${styles.ContentsWrapper} ${isMenuOnly ? styles.menuOnly : styles.contentOnly}`}>
        <div className={styles.sidebar}>
          <ManageNavebar />
        </div>
        <div className={styles.content}>
          {!isMenuOnly && (
            <div className={styles.mobileBackHeader} onClick={() => navigate(ROUTES.MANAGE)}>
              <ArrowBackIcon className={styles.backIcon} />
              <span>Back to Manage Menu</span>
            </div>
          )}
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default ManageLayout;
